export const SCHEDULE_WIDGET_LHASA_CLASS = 'ScheduleWidgetLhasa';
export const SCHEDULE_WIDGET_LHASA_BODY_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__Body`;
export const SCHEDULE_WIDGET_LHASA_NO_RACE_MESSAGE_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__NoRacesMessage`;
export const SCHEDULE_WIDGET_LHASA_TAB_CONTENTS_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__TabContents`;
export const SCHEDULE_WIDGET_LHASA_CATEGORY_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__Category`;
export const SCHEDULE_WIDGET_LHASA_CATEGORY_COLLAPSED_CLASS = `${SCHEDULE_WIDGET_LHASA_CATEGORY_CLASS}--Collapsed`;
export const SCHEDULE_WIDGET_LHASA_COLAPSE_CATEGORY_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__CollapseCategory`;
export const SCHEDULE_WIDGET_LHASA_CATEGORY_HEADER_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__CategoryHeader`;
export const SCHEDULE_WIDGET_LHASA_CATEGORY_HEADER_TEXT_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__CategoryHeaderText`;
export const SCHEDULE_WIDGET_LHASA_TIME_TO_RACING_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__TimeToRacing`;
export const SCHEDULE_WIDGET_LHASA_CATEGORY_BODY_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__CategoryBody`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__Tournament`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_FLAG_CLASS = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}Flag`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_EVENTS_CLASS = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}Events`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_NAME_CLASS = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}Name`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_ICONS = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}Icons`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_ICON = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}Icon`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_STREAMING_ICON = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}StreamingIcon`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_HEADLINES_ICON = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}HeadlineIcon`;
export const SCHEDULE_WIDGET_LHASA_TOURNAMENT_EW_PLUS_ICON = `${SCHEDULE_WIDGET_LHASA_TOURNAMENT_CLASS}EWPlusIcon`;

export const SCHEDULE_WIDGET_LHASA_EVENT_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__Event`;
export const SCHEDULE_WIDGET_LHASA_ANTEPOST_DATE_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__AntePostDate`;
export const SCHEDULE_WIDGET_LHASA_ANTEPOST_EVENTS_CLASS = `${SCHEDULE_WIDGET_LHASA_CLASS}__AntePostEvents`;
export const SCHEDULE_WIDGET_LHASA_ANTEPOST_EVENT_CONTAINER_CLASS = `${SCHEDULE_WIDGET_LHASA_ANTEPOST_EVENTS_CLASS}-event-container`;
export const SCHEDULE_WIDGET_LHASA_EVENT_TYPES = {
    upcomingEvent: 'upcoming-event',
    eventOff: 'event-off',
    resultsOnly: 'results-only',
    bog: 'bog',
    hasEWPlusClass: 'has-ew-plus',
    hasHeadlineClass: 'headlineIcon',
};
export const RACING_BOG_HEADER_CLASS = 'racing-bog-header';
export const RACING_BOG_HEADER_ICON_CLASS = `${RACING_BOG_HEADER_CLASS}__icon`;

export const SCHEDULE_WIDGET_LHASA_EVENT_WS_EVENT_OFF = 'event_off';
export const MEETING_LINK_CONTENT = 'meeting-link-content';
export const SHOULD_INTERNATIONAL_COLLAPSE = false;

export const INTERNATIONAL = 'international';
export const UK_IRELAND = 'uk-and-ireland';
export const EIRE = 'eire';
export const IRELAND = 'ireland';
export const NOTHERN_IRELAND = 'northern-ireland';
export const WALES = 'wales';
export const SCOTLAND = 'scotland';
export const ENGLAND = 'england';

export const BOG_CATEGORIES = [
    UK_IRELAND,
    EIRE,
    IRELAND,
    NOTHERN_IRELAND,
    WALES,
    SCOTLAND,
    ENGLAND,
];

export const SCHEDULE_URL = '/racing/getSchedule/';

const hour = 0;
const min = 0;
const sec = 0;
const msec = 0;

export const MIDNIGHT = [hour, min, sec, msec];

export const SAME = 0;
export const GREATER_THAN = 1;
export const LESS_THAN = -1;

export const NAV_TABS_CSS_CLASS_NAME = 'nav-tabs';
export const CAROUSEL_TABS_CSS_CLASS_NAME = 'carousel-tabs';
export const CAROUSEL_TABS_TAB_CSS_CLASS_NAME = `${NAV_TABS_CSS_CLASS_NAME}__tab`;
export const ANTEPOST = 'ante-post';

const INIT = 'init';
const NEW_SCHEDULE = 'new_schedule';
const UPDATE_FROM_WS = 'update_from_ws';
const SET_EMPTY_TABS = 'set_empty_tabs';
const CHANGE_TAB = 'change_active_tab';
const START_LOADING = 'start_loading';

export const ACTION_TYPES = {
    INIT,
    NEW_SCHEDULE,
    UPDATE_FROM_WS,
    SET_EMPTY_TABS,
    CHANGE_TAB,
    START_LOADING,
};

export const TAB_DEFAULT = 'today';
export const TAB_EMPTY = 'none';
export const TAB_ANTE_POST = 'ante-post';

export const WS_INTERFACE_HANDLER = 'preplay';
export const WS_EVENT_NAME_EVENTS_RESULTS = 'events_results';
export const WS_EVENT_NAME_EVENT_OFF = 'event_off';

export const MEETING_PAGE = 'meeting-page';
